<template>
  <path
    fill="currentColor"
    d="M6.22526 4.81108C5.83474 4.42056 5.20158 4.42056 4.81105 4.81108C4.42053 5.20161 4.42053 5.83477 4.81105 6.2253L10.5858 12L4.81111 17.7747C4.42059 18.1652 4.42059 18.7984 4.81111 19.1889C5.20164 19.5794 5.8348 19.5794 6.22532 19.1889L12 13.4142L17.7747 19.1889C18.1652 19.5794 18.7984 19.5794 19.1889 19.1889C19.5794 18.7984 19.5794 18.1652 19.1889 17.7747L13.4142 12L19.1889 6.2253C19.5795 5.83477 19.5795 5.20161 19.1889 4.81108C18.7984 4.42056 18.1653 4.42056 17.7747 4.81108L12 10.5858L6.22526 4.81108Z"
  />
</template>
